Object.assign(
    module.exports,
    require("./zsentry"),
);
